import React from "react";
import { IconBaseProps } from "react-icons";

export const AlphaBetAltSVG: React.FC<IconBaseProps> = ({ display, size = 26, fill = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
    display={display}
  >
    <path d="M5.9 18.997H3L6.867 7h3.551l3.84 11.997h-3.093l-.773-2.75h-3.71l-.782 2.75zm2.725-9.395h-.132L7.22 14.146h2.654L8.625 9.602zm11.839 8.27c-.317.65-1.072 1.266-2.452 1.266-1.837 0-3.103-1.064-3.103-2.848 0-1.714 1.187-2.804 3.375-2.804h2.171v-.782c0-.765-.475-1.186-1.266-1.186-.8 0-1.274.439-1.31 1.08h-2.627c.053-1.529.993-3.128 3.973-3.128 2.25 0 4.007.949 4.007 3.27v6.257h-2.645v-1.125h-.123zm-1.485-.694c.8 0 1.476-.492 1.476-1.24v-.922h-1.424c-.87 0-1.344.421-1.344 1.054 0 .739.632 1.108 1.292 1.108z" />
  </svg>
);
